module.exports = __webpack_public_path__ + "img/invoice-receipt-svgrepo-com.5f44f7b8.svg";